"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/dropdown/style/css");

var _dropdown = _interopRequireDefault(require("antd/es/dropdown"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

require("antd/es/tabs/style/css");

var _tabs = _interopRequireDefault(require("antd/es/tabs"));

var _icons = require("@ant-design/icons");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _FormTable = _interopRequireDefault(require("../../../components/form/FormTable"));

var _form = require("../../../redux/form/form.types");

require("./form.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const gridStyle = {
  width: '50%',
  height: '50%',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
};
const iconStyle = {
  background: '$font-color-primary'
};
const Tab = _tabs.default;
const validFormTypes = ['ADVERSE_EVENT', 'EARLY_TERMINATION', 'PROTOCOL_DEVIATION', 'SOCIAL_HARM'];

class Form extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      studyId: 1,
      activeForm: ''
    };

    this.setActiveForm = type => {
      if (!validFormTypes.includes(type)) {
        type = '';
      }

      this.setState({
        activeForm: type
      });
    };

    this.closeForm = () => {
      this.setState({
        activeForm: ''
      });
    };

    this.formOptions = /*#__PURE__*/_react.default.createElement(_menu.default, {
      onClick: this.handleMenuClick.bind(this)
    });

    this.renderFormModal = type => {
      switch (type) {
        default:
          return /*#__PURE__*/_react.default.createElement("div", null);
      }
    };
  }

  componentDidMount() {
    const {
      loadForms
    } = this.props;
    loadForms(this.state.studyId);
  }

  handleMenuClick(e) {
    this.setState({
      activeForm: e.key
    });
  }

  render() {
    const {
      activeForm
    } = this.state;
    const {
      forms
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "form"
    }, this.renderFormModal(activeForm), /*#__PURE__*/_react.default.createElement("div", {
      id: "tab-bar"
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      style: {
        background: 'white'
      },
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "form-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Forms"), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
        overlay: this.formOptions
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary"
      }, "+ Add Form", /*#__PURE__*/_react.default.createElement(_icons.DownOutlined, null))))
    }, /*#__PURE__*/_react.default.createElement(_FormTable.default, {
      forms: forms
    }))));
  }

}

const mapStateToProps = state => {
  const {
    pathname
  } = state.router.location;
  return {
    loadFormsStatus: selectors.loadRequestedFormsStatus(state),
    forms: selectors.getRequestedForms(state),
    currentPath: pathname
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadForms: studyId => dispatch(_form.getFormsAsync.request(studyId))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Form);

exports.default = _default;